import { useState, useEffect, useContext } from "react";
import { Option, Select } from "../select";
import { WorkflowsValue, WorkflowsDisbatch } from "../contexts/workflows";
import Dynamic from "./dynamic";
import styles from "./styles.module.css";

export default function Workflow({ value, onChange, sources = [] }) {
  const { workflows } = useContext(WorkflowsValue);
  const disbatch = useContext(WorkflowsDisbatch);
  const [workflow, setWorkflow] = useState(null);
  const [_value, setValue] = useState("");

  useEffect(() => {
    if (value) {
      const workflow = workflows[value.workflow];
      setWorkflow(workflow);
      setValue(value.workflow);
    } else {
      setWorkflow(null);
      setValue("");
    }
  }, [value]);

  const handleSelect = (value) => {
    if (!!value && typeof value === "object") {
      const _v = { ...value, workflow: value };
      onChange(_v);
    } else {
      onChange({
        workflow: value,
        props: {},
      });
    }
  };

  const handlePropChange = (edit, p) => {
    const _v = { ...value };
    if (_v) {
      _v.props[p.id] = edit;
      onChange(_v);
    } else {
    }
  };

  const handleAddWorkflow = () => {
    disbatch({ type: "setOpen", value: true });
  };

  return (
    <div>
      <Select
        addText={"Add Workflow"}
        onAdd={handleAddWorkflow}
        onChange={handleSelect}
        value={_value}
      >
        {Object.values(workflows).map((w) => {
          return (
            <Option key={w.id} value={w.id}>
              {w.name}
            </Option>
          );
        })}
      </Select>
      {workflow && workflow.params.length > 0 && (
        <>
          <div
            style={{ marginTop: 12, marginBottom: 8 }}
            className={styles.borderTitle}
          >
            Params
          </div>
          <div className={styles.workflowParams}>
            {value &&
              workflow.params.map((p) => {
                return (
                  <div style={{ marginBottom: 10 }} key={p.id}>
                    <div className={styles.workflowParamTitle}>{p.name}</div>
                    <Dynamic
                      value={value.props[p.id]}
                      onChange={(v) => handlePropChange(v, p)}
                      params={{ type: p.type, list: p.list }}
                      sources={sources}
                    />
                  </div>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
}
